'use client';

import { useState } from 'react';
import { iconWrapper, icon, visibleIcon, hiddenIcon } from './checkmark-button.css';
import { Button, ButtonProps } from '../button/button';
import { Check, X } from 'lucide-react';

type CheckmarkButtonProps = ButtonProps;

export const CheckmarkButton: React.FC<CheckmarkButtonProps> = ({ size = 'xs', ...rest }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Button
      size={size}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...rest}
    >
      <div className={iconWrapper}>
        <Check
          size={11}
          color="white"
          className={`${icon} ${isHovered ? hiddenIcon : visibleIcon}`}
        />
        <X size={11} color="white" className={`${icon} ${isHovered ? visibleIcon : hiddenIcon}`} />
      </div>
    </Button>
  );
};
